"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomCourseByUUID = exports.verifyDeleteMock = exports.mockCustomCoursesDefaultIcon = exports.mockLessons = exports.mockVerifyUnpublished = exports.getCustomContent = exports.mockCustomCoursesIcons = exports.getCustomCourse = void 0;
/* eslint-disable import/prefer-default-export */
exports.getCustomCourse = {
    success: true,
    data: [
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: 'ae70bae2-e0d5-476a-b840-04498ac8eb57',
            displayName: 'arie test course',
            description: 'sdfsdfsdfsdfsdf',
            tagline: 'sdfsdfsdfsdfsdf',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 0,
            updatedAt: '2024-03-28T18:50:18.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: ['Arie Test Lesson', 'nir lesson'],
            duration: 8,
            creator: {
                uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
                fullName: 'arie testing testing test',
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '504c4456-387c-46ef-9aaf-ed0c1cb4a093',
            displayName: 'test Chedva',
            description: 'test',
            tagline: 'test',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-27T11:22:24.000Z',
            isHaveQuiz: true,
            lessonsDisplayNames: [' Command Injections', ' Command Injection', 'sefewwe'],
            duration: 30,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'testq@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '9ceac227-cc4f-4821-ac38-fdad1bec6a6b',
            displayName: 'fix sort',
            description: 'fix sort',
            tagline: 'fix sort',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-24T06:21:12.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: [' Command Injections', ' Identification and Authentication Failures'],
            duration: 10,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'test1@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '1e0fa62a-dc76-4172-9fbc-8c3af0bff73f',
            displayName: 'aaa',
            description: 'aaaaa',
            tagline: 'aaaaa',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-25T07:54:06.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: [
                ' Command Injections',
                ' Identification and Authentication Failures',
                ' Identification and Authentication Failures',
                ' Sensitive Data Exposure',
                'Access to Docker Registry',
                'Access Management',
                'A test lesson (miriam)',
                '.NET',
                ' Separating Authentication',
                ' Command Injection',
            ],
            duration: 50,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'testn@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '851ed2fe-60eb-4123-8ddb-326c8861e9b2',
            displayName: 'fdsfds',
            description: 'fsdf',
            tagline: 'fsdf',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 0,
            updatedAt: '2024-03-25T08:06:07.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: ['val test'],
            duration: 42,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'tets.test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: 'e072ce1c-1016-4f15-8e86-fd955f651b18',
            displayName: 'HelloMyNameIsInigoMontoyaYouKilledMyFatherPrepareToDie',
            description: 'test test test',
            tagline: 'test test test',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 0,
            updatedAt: '2024-03-26T14:33:17.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: [' Command Injection', ' Command Injections', ' Identification and Authentication Failures'],
            duration: 15,
            creator: {
                uuid: '07a19297-6a4d-404c-8b0c-c92109e09126',
                fullName: 'Guy Rotem',
                email: '5es52@test.com',
                profilePictureUrl: null,
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: 'c350cfd3-dd45-4987-b89d-963862f6056c',
            displayName: 'nir_course_with_quiz',
            description: 'course_with_quiz',
            tagline: 'course_with_quiz',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-26T15:25:13.000Z',
            isHaveQuiz: false,
            lessonsDisplayNames: [' Command Injection'],
            duration: 5,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'yytt@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '9004c101-e6f6-43e1-901c-eb39c038cc6f',
            displayName: 'quiz',
            description: '11',
            tagline: '11',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-27T13:04:24.000Z',
            isHaveQuiz: true,
            lessonsDisplayNames: ['Achievements', '.NET', ' Command Injections'],
            duration: 15,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'test.check@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '56579c32-30b2-44fe-bcde-3b6c47465451',
            displayName: 'test11111',
            description: 'test',
            tagline: 'test',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-28T21:04:07.000Z',
            isHaveQuiz: true,
            lessonsDisplayNames: ['A test lesson (miriam)', '.NET', 'Achievements', 'Android'],
            duration: 20,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'test5@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
        {
            enableCertificate: true,
            certificateAwardCondition: 'on_complete',
            uuid: '367c03b6-f416-452e-b314-0116fc34575c',
            displayName: 'test2121',
            description: 'aaa',
            tagline: 'aaa',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            isPublished: 1,
            updatedAt: '2024-03-28T21:07:57.000Z',
            isHaveQuiz: true,
            lessonsDisplayNames: ['Android'],
            duration: 5,
            creator: {
                uuid: 'd93e21f3-0a4a-4336-9a3c-d457180a7429',
                fullName: null,
                email: 'test@test.com',
                profilePictureUrl: 'https://picsum.photos/200/300?random=1',
            },
        },
    ],
    total: 16,
};
exports.mockCustomCoursesIcons = [
    'https://picsum.photos/200?random=1',
    'https://picsum.photos/200?random=2',
    'https://picsum.photos/200?random=3',
    'https://picsum.photos/200?random=4',
    'https://picsum.photos/200?random=5',
    'https://picsum.photos/200?random=6',
];
exports.getCustomContent = {
    totalCourses: 10,
    totalLessons: 20,
    success: true,
};
exports.mockVerifyUnpublished = {
    publishedCourses: [
        {
            displayName: 'ciso test 5111',
            iconUrl: 'https://picsum.photos/200/300?random=1',
        },
    ],
    usersProgress: {
        notStarted: 591,
        started: 6,
        completed: 1,
    },
};
exports.mockLessons = {
    data: [
        {
            uuid: '6167f207c27d3da0e395294a',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: ' Command Injection',
            type: 'system',
            systemCourse: '.NET: Backend Security Basics',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '64abe5fbb51cd23955827d90',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: ' Command Injections',
            type: 'system',
            systemCourse: 'OWASP: Java - API Security ',
            customCourses: [],
            duration: '5-8',
        },
        {
            uuid: '6167f2038df887724776a557',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: ' Identification and Authentication Failures',
            type: 'system',
            systemCourse: 'Application Security for QA',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'appsec for qa test', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f1ffc27d3df88a952935',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: ' Identification and Authentication Failures',
            type: 'system',
            systemCourse: 'Application Security for Decision Makers',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f2022479f1807bd5571d',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: ' Sensitive Data Exposure',
            type: 'system',
            systemCourse: 'Application Security for Decision Makers',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f227c27d3dc6929529b8',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: ' Separating Authentication',
            type: 'system',
            systemCourse: '.NET - API Security',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f271c27d3d1f9b952aae',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: '.NET',
            type: 'system',
            systemCourse: 'Source Code',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '633936eed05748ff624e3121',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: 'A test lesson (miriam)',
            type: 'system',
            systemCourse: 'Miriam testing course',
            customCourses: [],
            duration: '5-8',
        },
        {
            uuid: '61c43c8cf381131fc9513e57',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: 'Access Management',
            type: 'system',
            systemCourse: 'course builder course name edited',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'dd', 'test-points'],
            duration: '5-8',
        },
        {
            uuid: '65686076aeeb49a4225e052b',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: 'Access to Docker Registry',
            type: 'system',
            systemCourse: 'Docker',
            customCourses: [],
            duration: '5-8',
        },
        {
            uuid: '653521027c356a536c3c9091',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: 'Achievements',
            type: 'system',
            systemCourse: 'Attacker Perspective: Faking GitHub Profile',
            customCourses: [],
            duration: '1-2',
        },
        {
            uuid: '6167f2708df887132976a6bb',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: 'Android',
            type: 'system',
            systemCourse: 'Source Code',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f1fac27d3dcee7952923',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: 'Angular anti XSS mechanism - html sanitizer',
            type: 'system',
            systemCourse: 'Angular 2+',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '6167f1fa2479f1f7fcd55705',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: true,
            displayName: 'Angular anti XSS mechanism - URL sanitizer',
            type: 'system',
            systemCourse: 'Angular 2+',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
        {
            uuid: '64243c86f57940d67fa958f1',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: 'Another lesson with 1920 size frame',
            type: 'system',
            systemCourse: 'Content Bar Test',
            customCourses: [],
            duration: '5-8',
        },
        {
            uuid: '6167f2312479f1a315d557b9',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            hasChallenge: false,
            displayName: 'Apache Unomi',
            type: 'system',
            systemCourse: 'Hacking Headlines',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'rffrr'],
            duration: '5-8',
        },
    ],
    total: 583,
};
exports.mockCustomCoursesDefaultIcon = ["".concat(process.env.PUBLIC_URL, "/images/courseDefaultCard.svg")];
exports.verifyDeleteMock = {
    publishedCourses: [],
    unpublishedCourses: [
        {
            displayName: 'tesr',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            uuid: '2f116004-d63f-4293-831e-3b5c9df2c487',
        },
    ],
    usersProgress: {
        notStarted: 599,
        started: 0,
        completed: 0,
    },
};
exports.getCustomCourseByUUID = {
    data: {
        uuid: '6ad1b7cb-9392-468f-9184-bc5fe00bc4c7',
        displayName: 'CISO test 2',
        description: 'CISO test 2',
        tagline: 'CISO test 2',
        iconUrl: 'https://picsum.photos/200/300?random=1',
        isPublished: 1,
        updatedAt: '2023-10-24T18:39:48.000Z',
        lessonsDisplayNames: ['CISO test 2', 'Reflected XSS'],
        duration: 5,
        creator: {
            uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
            fullName: 'arie testing testing test',
            email: 'arie.belenky@test.com',
            profilePictureUrl: 'https://picsum.photos/200/300?random=1',
        },
        lessons: [
            {
                uuid: '6167f220c27d3d842e95299d',
                displayName: 'Second Order SQL Injection',
                iconUrl: 'https://picsum.photos/200/300?random=1',
                contentType: 'lesson',
            },
            {
                uuid: '6167f2212479f131a8d55783',
                displayName: 'SQL Injection',
                iconUrl: 'https://picsum.photos/200/300?random=1',
                contentType: 'lesson',
            },
            {
                uuid: '6167f21f8df88744cd76a5aa',
                displayName: 'Command Injection',
                iconUrl: 'https://content.codebashing.com/courses-assets/command_injection.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f221c27d3d75049529a0',
                displayName: 'Session Fixation',
                iconUrl: 'https://content.codebashing.com/courses-assets/session_fixation.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f21fc27d3d654b95299a',
                displayName: 'Cross Site Request Forgery',
                iconUrl: 'https://content.codebashing.com/courses-assets/cross_site_request_forgery.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f2202479f181f5d55780',
                displayName: 'Server Side Request Forgery ',
                iconUrl: 'https://codebashing-prod-eu-content.s3.eu-west-1.amazonaws.com/courses-assets/cross_site_request_forgery_post.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f222c27d3df76c9529a3',
                displayName: 'Use Of Insufficiently Random Values',
                iconUrl: 'https://content.codebashing.com/courses-assets/use_of_insufficiently_random_values.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f2218df887102076a5b0',
                displayName: 'Stored (Persistent) XSS ',
                iconUrl: 'https://content.codebashing.com/courses-assets/stored_persistent_xss.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f2208df887508d76a5ad',
                displayName: 'Reflected XSS',
                iconUrl: 'https://content.codebashing.com/courses-assets/reflected_xss.png',
                contentType: 'lesson',
            },
            {
                uuid: '6167f2202479f1443ad5577d',
                displayName: 'Path Traversal',
                iconUrl: 'https://content.codebashing.com/courses-assets/directory_path_traversal.png',
                contentType: 'lesson',
            },
        ],
        enableCertificate: true,
        certificateAwardCondition: 'on_quiz_complete',
        quizData: {
            numberOfQuestions: 2,
            incorrectQuestionsAllowed: 1,
            attemptsAllowed: 3,
            fileName: 'questions.csv',
            questions: [
                {
                    question: 'question 1',
                    answer1: 'answer 1',
                    answer2: 'answer 2',
                    answer3: 'answer 3',
                    answer4: 'answer 4',
                    correctAnswer: 1,
                },
                {
                    question: 'question 2',
                    answer1: 'answer 1',
                    answer2: 'answer 2',
                    answer3: 'answer 3',
                    answer4: 'answer 4',
                    correctAnswer: 2,
                },
                {
                    question: 'question 3',
                    answer1: 'answer 1',
                    answer2: 'answer 2',
                    answer3: 'answer 3',
                    answer4: 'answer 4',
                    correctAnswer: 4,
                },
            ],
        },
    },
};
